import { level, masteredFacts, zoneUpto, type Progress } from './progress'

export interface StickerStats {
  masteredFacts: number
  streak: number
  level: number
  xp: number
  /** Наибольший освоенный рубеж «до N» — для наклеек за зоны. */
  zoneUpto: number
}

export interface StickerDef {
  icon: string
  /** Как называется наклейка в «Достижениях». */
  title: string
  /** Что нужно сделать, чтобы открыть. */
  hint: string
  /** Каким акцентом темы красится плитка. */
  tint: 'acc' | 'acc2' | 'warn'
  /** Открывается, когда возвращает true. */
  test: (s: StickerStats) => boolean
}

export const STICKERS: StickerDef[] = [
  { icon: '🦊', title: 'Первый шаг', hint: 'Сыграть первую игру', tint: 'acc2', test: (s) => s.xp > 0 },
  { icon: '🚀', title: 'Разгон', hint: 'Выучить 10 примеров', tint: 'acc', test: (s) => s.masteredFacts >= 10 },
  { icon: '🏅', title: 'До пяти', hint: 'Выучить всю таблицу до 5', tint: 'warn', test: (s) => s.zoneUpto >= 5 },
  { icon: '🐙', title: 'Три дня', hint: 'Играть 3 дня подряд', tint: 'warn', test: (s) => s.streak >= 3 },
  { icon: '🐝', title: 'Трудяга', hint: 'Выучить 25 примеров', tint: 'acc2', test: (s) => s.masteredFacts >= 25 },
  { icon: '🦖', title: 'Пять дней', hint: 'Играть 5 дней подряд', tint: 'acc', test: (s) => s.streak >= 5 },
  { icon: '🐳', title: 'Глубина', hint: 'Выучить 40 примеров', tint: 'warn', test: (s) => s.masteredFacts >= 40 },
  { icon: '🎖️', title: 'До семи', hint: 'Выучить всю таблицу до 7', tint: 'acc', test: (s) => s.zoneUpto >= 7 },
  { icon: '🦉', title: 'Мудрец', hint: 'Дойти до 5 уровня', tint: 'acc2', test: (s) => s.level >= 5 },
  { icon: '🐉', title: 'Дракон', hint: 'Выучить 60 примеров', tint: 'acc', test: (s) => s.masteredFacts >= 60 },
  { icon: '🦄', title: 'Десять дней', hint: 'Играть 10 дней подряд', tint: 'warn', test: (s) => s.streak >= 10 },
  { icon: '🛸', title: 'Космос', hint: 'Выучить 75 примеров', tint: 'acc2', test: (s) => s.masteredFacts >= 75 },
  { icon: '🏆', title: 'До девяти', hint: 'Выучить всю таблицу до 9', tint: 'acc2', test: (s) => s.zoneUpto >= 9 },
  { icon: '⭐', title: 'Звезда', hint: 'Дойти до 15 уровня', tint: 'acc', test: (s) => s.level >= 15 },
  { icon: '👑', title: 'Вся таблица', hint: 'Выучить все 81 пример', tint: 'warn', test: (s) => s.masteredFacts >= 81 },
]

export const STICKER_TOTAL = STICKERS.length

export function stickerStats(progress: Progress): StickerStats {
  return {
    masteredFacts: masteredFacts(progress),
    streak: progress.streak,
    level: level(progress),
    xp: progress.xp,
    zoneUpto: zoneUpto(progress),
  }
}

/** Сколько наклеек открыто — считается одинаково на клиенте и на сервере. */
export function unlockedStickers(progress: Progress): number {
  const stats = stickerStats(progress)
  return STICKERS.filter((def) => def.test(stats)).length
}

/** Названия открытых наклеек — по ним сервер строит события ленты. */
export function unlockedStickerTitles(progress: Progress): string[] {
  const stats = stickerStats(progress)
  return STICKERS.filter((def) => def.test(stats)).map((def) => `${def.icon} «${def.title}»`)
}
